import { render, staticRenderFns } from "./Tarife.vue?vue&type=template&id=52b326ba&"
import script from "./Tarife.vue?vue&type=script&lang=js&"
export * from "./Tarife.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports